import React, { ComponentProps } from "react";

import { AccordionTag } from "./styles";

export const AccordionDivider = (props: ComponentProps<"div">) => (
  <AccordionTag.Step.Divider {...props} />
);
